import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const SmallX = (props) => (
  <Icon viewBox="0 0 6 6" {...props}>
    <g>
      <path fill="currentColor" d="M5.25 0L3 2.25.75 0 0 .751l2.25 2.25L0 5.251.75 6 3 3.75 5.25 6l.751-.749-2.25-2.25 2.25-2.25z" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default SmallX;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/SmallX.js